<div (window:keydown.esc)="cancel()" class="lg:ps-6 pe-4 lg:pb-4 pb-2 ps-4" role="button" tabindex="0">
  <div class="flex justify-end pt-4" >
    <button class="size-6 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group"
            [mat-dialog-close]="true" (click)="cancel()" matTooltip="Close">

      <!-- Gray cross (default) -->
      <img src="./assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden"
           alt="gray cross" height="10" width="10">

      <!-- White cross (on hover) -->
      <img src="./assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block"
           alt="white cross" height="10" width="10">
    </button>
  </div>

  <div [style.pointer-events]="!changeWorker? 'none' : 'auto'"
                    [style.opacity]="!changeWorker? '0.6' : '1'"class="lg:flex justify-between items-end pe-6">
    
     
		<bk-button
      variant="secondary"
      label="Add Team Member Hours"
      size="sm"
      [loading]="false"
      leftIcon="../../../../../../assets/images/icons/ticket-detail/add-profile.svg"
      iconAlt="plus"
      [disabled]="false"
      buttonClass="text-[#15191E] border-[#E3E6EE] bg-white w-full !py-[5px] rounded-md"
      (clicked)="AddTeamMemberAndHour()"
    >
    </bk-button>
  </div>
  <app-team-hour [getTicket]="getTicket" [ticketId]="ticketId" [isChange]="isChangeAnything"></app-team-hour>
</div>